import { render, staticRenderFns } from "./revisionSistemasShow.vue?vue&type=template&id=706059cc&scoped=true&"
import script from "./revisionSistemasShow.vue?vue&type=script&lang=js&"
export * from "./revisionSistemasShow.vue?vue&type=script&lang=js&"
import style0 from "./revisionSistemasShow.vue?vue&type=style&index=0&id=706059cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706059cc",
  null
  
)

export default component.exports